import { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import {
  DOWNLOADPAYMENTREPORT,
  GETALLPRODUCTS,
  GETCATEGORIESLIST,
  GETCATEGORYFIELDS,
  GETPAYMENTREPORT,
  UPDATE_CATEGORY,
} from "../../api/apiConfig";
import { apiGet, apiPost } from "../../utils/services";
import {
  Paper,
  Radio,
  Tab,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Button,
  Stack,
} from "@mui/material";

import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Title } from "../../components/atoms";
import { useCallback } from "react";
import Select from "react-select";
import { useQuery } from "react-query";
import { getProductModels } from "../../api/api";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import { FaFileDownload, FaForward, FaInfoCircle } from "react-icons/fa";
import Popup from "../../components/atoms/Popup/Popup";
import Modal from "react-responsive-modal";
import {
  BiDownArrow,
  BiDownload,
  BiLoaderCircle,
  BiRightArrow,
  BiUpArrow,
} from "react-icons/bi";
import { moneyFormat } from "../../components/atoms/Helper/helper";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import CircularProgress from "@mui/material/CircularProgress";
import { endpoints } from "../../api/Config";
import { error } from "is_js";

const Payments = () => {
  const [isLoading, setIsLoading] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 900px)" });
  const [data, setData] = useState();
  const [popup, setPopup] = useState({});
  const [state, setState] = useState({
    productCategories: [],
  });

  const [subOpen, setSubOpen] = useState(0);
  const [open, setOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [xeroLoading, setXeroloading] = useState(false);
  const [xeroActivated, setXeroActivated] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const openPopup = (name, e) => {
    setPopup({ ...popup, [name]: popup[name] ? null : e.currentTarget });
  };
  const closePopup = () => {
    setPopup({});
  };
  const updateState = (data) =>
    setState((prevState) => ({ ...prevState, ...data }));

  const {
    productCategories,
    selectedCategory,
    selectedModel,
    startDate,
    endDate,
  } = state;

  useEffect(() => {
    getPaymentReport();
  }, [startDate, endDate]);

  useEffect(() => {
    setXeroloading(true);
    fetch(`${endpoints.baseURL}Integration/xero/getVendorStatus`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setXeroloading(false);
        setXeroActivated(data.isXeroActivated);
      })
      .catch((error) => console.error(error));
  }, []);

  const prodCategories =
    productCategories &&
    productCategories.map((m) => ({
      value: m.id,
      label: m.name,
    }));

  const setSelectedProductModel = (option) => {
    updateState({ selectedModel: option });
  };

  const currentCategory = selectedCategory?.label
    ? selectedCategory
    : prodCategories[0];

  const {
    isLoading: isProductModelsLoading,
    data: { data: productModels } = { data: [] },
  } = useQuery(
    ["models", selectedCategory?.value],
    () => getProductModels(currentCategory.value),
    {
      enabled: currentCategory != null,
    }
  );

  const getPaymentReport = async () => {
    const filter = {
      from: startDate == null ? "" : moment(startDate).format("DD/MM/yyyy"),
      to: endDate == null ? "" : moment(endDate).format("DD/MM/yyyy"),
    };
    setIsLoading(true);
    const res = await apiPost(GETPAYMENTREPORT, filter);
    if (res) {
      setData(res);
    }
    setIsLoading(false);
  };

  const heading = [
    { id: 1, name: "Payout" },
    { id: 2, name: "Banking" },
    { id: 3, name: "Xero Accounting" },
  ];

  const [value, setValue] = useState(1);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="tabPanelCls h-100">
      <Toaster />

      <div className="dispatchTimer" style={{ position: "relative" }}>
        <div style={{ width: "100%", background: "white" }}>
          <div className="header fixed">
            <h2 style={{ paddingTop: "5px" }}>Payments</h2>
          </div>
        </div>

        <Box
          style={{ marginTop: "35px" }}
          sx={{ width: "100%", typography: "body1" }}
        >
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                style={{ borderBottom: "solid 3px red" }}
                className="fixed"
                onChange={handleChange}
              >
                {heading.map((d) => {
                  return (
                    <Tab
                      sx={{ fontSize: "16px", fontWeight: "600" }}
                      label={d.name}
                      value={d.id}
                    />
                  );
                })}
              </TabList>
            </Box>
            <TabPanel value={1} style={{ marginTop: "60px" }}>
              {getPayout()}
            </TabPanel>
            <TabPanel value={2}>{getBankView()}</TabPanel>
            <TabPanel value={3}>{getXeroView()}</TabPanel>
          </TabContext>
        </Box>
      </div>
    </div>
  );

  function getBankView() {
    return (
      <div>
        <Paper
          className="center"
          style={{ marginTop: "50px", padding: "100px 50px" }}
        >
          <Button
            size="large"
            onClick={() =>
              window.open(
                "https://dashboard.stripe.com/dashboard",
                "_blank",
                "noreferrer"
              )
            }
            variant="contained"
          >
            Go To Stripe Account
          </Button>
        </Paper>
      </div>
    );
  }

  function getXeroView() {
    return (
      <div>
        <Paper
          className="center"
          style={{ marginTop: "50px", padding: "100px 50px" }}
        >
          {xeroLoading ? (
            <CircularProgress />
          ) : (
            <>
              {!xeroActivated ? (
                <Button
                  size="large"
                  onClick={() => {
                    let vendor = localStorage.getItem("userName");

                    // window.open(
                    //   `${endpoints.baseURL}Integration/xero/authorize/${vendor}`,
                    //   "_self",
                    //   "noreferrer"
                    // );

                    fetch(
                      `${endpoints.baseURL}Integration/xero/authorize/${vendor}`,
                      {
                        headers: {
                          Authorization: `Bearer ${localStorage.getItem(
                            "access_token"
                          )}`,
                        },
                      }
                    )
                      .then((res) => res.json())
                      .then((data) => {
                        console.log(data);
                        window.open(data.url, "_self");
                      })
                      .catch((error) => console.error(error));
                  }}
                  variant="contained"
                >
                  Link Xero Account
                  {/* {xeroActivated ? "Xero Account Linked ✅" : ""} */}
                </Button>
              ) : (
                <Button variant="contained">Xero Account Linked ✅</Button>
              )}
            </>
          )}
        </Paper>
      </div>
    );
  }

  function getPayout() {
    function placeValue(title, value, direction, weight) {
      return (
        <div>
          <div className="bold">{title}</div>
          <div direction="row" spacing={1} className=" space-top2">
            <div className="bold lg inline">{value == null ? "0" : value}</div>
            {/* {direction == 1 ?
              <div className="red ruby center">
                <BiDownArrow />
                {weight}
              </div>
              :
              <div className="green ruby">
                <BiUpArrow />
                {weight}
              </div>
            } */}
          </div>
        </div>
      );
    }
    const values = [
      {
        id: 1,
        name: "Revenue",
        info: "Info",
        value: data?.model.totalAmount,
        list: data?.model.lineItems,
      },
      { id: 2, name: "Marketing", info: "Info", value: 0, list: [] },
      {
        id: 3,
        name: "TCS Fees",
        info: "Info",
        value: data?.model.tcsFee,
        list: data?.model.lineItems.map((e) => {
          return { ...e, price: e.price * 0.2 };
        }),
      },
      {
        id: 4,
        name: "Total payout",
        info: "Info",
        value: data?.model.netPayment,
        list: data?.model.lineItems.map((e) => {
          return { ...e, price: e.price - e.price * 0.2 };
        }),
      },
    ];
    const filter = {
      from: startDate == null ? "" : moment(startDate).format("DD/MM/yyyy"),
      to: endDate == null ? "" : moment(endDate).format("DD/MM/yyyy"),
    };
    return (
      <div>
        <Grid container spacing={2}>
          <Grid item md={8}>
            <Grid container spacing={2}>
              <Grid item md={"auto"} xs={5}>
                <DatePicker
                  placeholderText="Select date"
                  className="datepicker click"
                  onChange={(date) => {
                    updateState({ startDate: date });
                  }}
                  selectsStart
                  showMonthDropdown
                  showYearDropdown
                  value={
                    startDate != null && moment(startDate).format("DD/MM/yyyy")
                  }
                  dropdownMode="select"
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  startDate={startDate}
                  endDate={endDate}
                  maxDate={endDate}
                />
              </Grid>
              <Grid item md={"auto"} xs={2} className="center">
                to
              </Grid>
              <Grid item md={"auto"} xs={5}>
                <DatePicker
                  placeholderText="Select date"
                  className="datepicker click"
                  onChange={(date) => {
                    updateState({ endDate: date });
                  }}
                  selectsStart
                  showMonthDropdown
                  showYearDropdown
                  value={
                    endDate != null && moment(endDate).format("DD/MM/yyyy")
                  }
                  dropdownMode="select"
                  dateFormat="dd/MM/yyyy"
                  selected={endDate}
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={4} xs={12} className="push-right">
            <Button
              onClick={async () => {
                let userData = localStorage.getItem("access_token");
                const url = DOWNLOADPAYMENTREPORT;
                setIsDownloading(true);
                axios({
                  url, //your url
                  method: "GET",
                  responseType: "blob", // important
                  headers: {
                    authorization: `Bearer ${userData}`,
                  },
                })
                  .then((response) => {
                    setIsDownloading(false);
                    // create file link in browser's memory
                    const href = URL.createObjectURL(response.data);

                    // create "a" HTML element with href to file & click
                    const link = document.createElement("a");
                    link.href = href;
                    link.setAttribute("download", "PaymentReport.csv"); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                  })
                  .catch((e) => {
                    setIsDownloading(false);
                  });
              }}
              sx={{ background: "#F0F0F0", color: "black" }}
              startIcon={
                isDownloading ? (
                  <BiLoaderCircle sx={{ color: "#8D0C18" }} />
                ) : (
                  <BiDownload sx={{ color: "#8D0C18" }} />
                )
              }
              variant="contained"
            >
              Download
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={2} className="space-top">
          <Grid item md={3} xs={12} className={isTabletOrMobile && "center"}>
            {placeValue("Total Payout", moneyFormat(data?.totalPayout), 1, 27)}
          </Grid>
          <Grid item md={2} xs={4}>
            {placeValue("Customers", data?.customers.length, 2, 0)}
          </Grid>
          <Grid item md={1} xs={4} className="center">
            {placeValue("Orders", data?.orderList.length, 2, 0)}
          </Grid>
          <Grid item md={6} xs={4} className="push-right">
            {placeValue("Refunds", moneyFormat(data?.refunds), 2, 0)}
          </Grid>
        </Grid>

        <div className="space-top3 md bold">Payout Breakdown</div>
        {data?.nextMonday != null && (
          <div>
            Your next payout is{" "}
            {moment(data?.nextMonday).format("dddd MMM Do, YYYY")}. Payments are
            usually deposited within 1-3 business days, but may vary depending
            on your bank.
          </div>
        )}
        <Paper className="padding space-top">
          <Table style={{ tableLayout: "fixed" }}>
            <TableBody>
              {values?.map((data) => {
                const getTitle = (d) => {
                  switch (d) {
                    case 1:
                      return "Price";
                    case 2:
                      return "Fee";
                    case 3:
                      return "Fee";
                    case 4:
                      return "Payout";
                  }
                };
                return (
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell width={isTabletOrMobile?"80%":"90%"}>
                      <Stack direction={"row"} spacing={2} className="center">
                        {subOpen != data.id ? (
                          <BiRightArrow
                            className="click"
                            onClick={() => setSubOpen(data.id)}
                          />
                        ) : (
                          <BiDownArrow
                            className="click"
                            onClick={() => setSubOpen(0)}
                          />
                        )}
                        <span>{data.name}</span>
                        {/* <FaInfoCircle color="black" className="click"  onClick={(e)=>openPopup('info',e)}/> */}
                      </Stack>

                      <div
                         style={{
                          display:
                            (subOpen != data.id || data.list?.length == 0) &&
                            "none",
                        }}
                      >
                        <Table
                          size="small"
                          style={{
                            maxWidth: isTabletOrMobile ? "unset" : "unset",
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                xs={3}
                               
                              >
                                <span className="bold">
                                  {isTabletOrMobile ? "No" : "Order No"}
                                </span>
                              </TableCell>
                              <TableCell
                                xs={2}
                               
                              >
                                <span className="bold">Quantity</span>
                              </TableCell>
                              <TableCell
                                xs={5}
                              >
                                <span className="bold">Item</span>
                              </TableCell>
                              <TableCell
                                xs={2}
                              
                              >
                                <span className="bold">
                                  {getTitle(data.id)}
                                </span>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {data.list?.map((d) => {
                              return (
                                <TableRow
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell>
                                    <span>{d.orderNo}</span>
                                  </TableCell>
                                  <TableCell>
                                    <span>{d.quantity}</span>
                                  </TableCell>
                                  <TableCell>
                                    <span>{d.title}</span>
                                  </TableCell>
                                  <TableCell>
                                    <span>{moneyFormat(d.price)}</span>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </div>
                    </TableCell>
                    {(subOpen != data.id || data.list?.length == 0) && (
                      <TableCell align="right">
                        <span>{moneyFormat(data.value)}</span>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Popup target={popup.info}>
            <div
              className="center padding2 white"
              style={{
                maxHeight: "300px",
                width: "300px",
                overflowY: "auto",
                background: "#DE031E",
                borderRadius: "10px 10px 0px 0px",
              }}
            >
              <FaInfoCircle
                size={15}
                color="white"
                className="center3"
                style={{ width: "100%" }}
              />
              <div className="xl bold">Information</div>
              <div className="sm">
                This is a discount on the current price the item is listed on
                the store at. The price will revert to the current price
                following the expiry of the top deal campaign.
              </div>
            </div>
            <Button
              onClick={() => closePopup()}
              variant="contained"
              fullWidth
              sx={{ background: "white", color: "#DE031E" }}
            >
              Ok
            </Button>
          </Popup>
        </Paper>
      </div>
    );
  }
};

export default Payments;
